module.exports = __webpack_public_path__ + "static/media/avatar.9687172e.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/HomePage/internalComponents/avatar.png
// module id = 185
// module chunks = 0